import { courseRuntimeUrl } from './courseRuntimeContext';
import api from '../httpClient';
import type { Question } from '../../types';

export interface QuestionNarrationResponse {
  audio_url: string;
  mime_type: string;
  cache_key: string;
}

export const questions = {
  getAll: () => api.get<Question[]>('/api/questions/'),
  getNext: () => api.get('/api/questions/next/'),
  getActive: () => api.get('/api/questions/active/'),
  getNarration: (questionId: number, prefetchQuestionIds: number[] = []) => {
    const params = new URLSearchParams();
    prefetchQuestionIds.slice(0, 2).forEach((id) => {
      params.append('prefetch_question_ids', String(id));
    });
    const query = params.toString();
    const path = query ? `/api/questions/${questionId}/tts/?${query}` : `/api/questions/${questionId}/tts/`;
    return api.get<QuestionNarrationResponse>(courseRuntimeUrl(path)).then((response) => response.data);
  },
  create: async (data: any) => {
    if (data.use_external_url) {
      const jsonData = { ...data };
      delete jsonData.video_file;
      delete jsonData.image_file;
      delete jsonData.use_external_url;
      return api.post('/api/questions/', jsonData);
    }

    const formData = new FormData();

    if (data.video_file) {
      formData.append('video', data.video_file);
      delete data.video_file;
    }

    if (data.image_file) {
      formData.append('image', data.image_file);
      delete data.image_file;
    }

    delete data.use_external_url;

    Object.keys(data).forEach((key) => {
      if (key === 'options') {
        formData.append('options', JSON.stringify(data.options));
      } else {
        formData.append(key, data[key]);
      }
    });

    return api.post('/api/questions/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  update: (id: number, data: any) => api.put(`/api/questions/${id}/`, data),
  delete: (id: number) => api.delete(`/api/questions/${id}/`),
  deactivate: (id: number) => api.post(`/api/questions/${id}/deactivate/`),
  activate: (id: number) => api.post(`/api/questions/${id}/activate/`),
  updateSummary: (questionId: number, summary: string) =>
    api.put<{
      summary: string;
      summary_type: 'ai' | 'template';
    }>(courseRuntimeUrl(`/api/questions/${questionId}/summary/`), { summary_text: summary }),
};
